import React, { useEffect, useState } from 'react';
import { array, string } from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import template from 'url-template';
import { isEmpty } from 'lodash';
import * as ArchitectActions from '../../../actions/architectActions';
import * as BobActions from '../../../actions/bobActions';
import * as SiteActions from '../../../actions/siteActions';
import * as UiActions from '../../../actions/uiActions';
import * as classes from '../../../components/BobFilterComponent.module.css';
import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import useApi from '../../../hooks/useApi';
import lambdaBaseApi from '../../../apis/lambda';
import { statusList } from '../../../data/schedulerStatus';

const IssueTypesUrl = template.parse('/issuetypes');

const formattedPriorities = [
    {
        id:   2,
        name: 'High'
    },
    {
        id:   1,
        name: 'Medium'
    },
    {
        id:   0,
        name: 'Low'
    }
];

const BobServiceManagementFilter = ({
    companyInfo,
    fetchClientSites,
    fetchNavClients,
    fetchEquipmentsBySiteId,
    navClients,
    sites,
    toggleLoading,
    targetNavClient,
    targetNavSite,
    technicians,
    seniorityLevels,
    specialties,
    ...props
}) => {

    const [filterOpen, setFilterOpen] = useState(false);
    const [formattedIssueTypes, setFormattedIssueTypes] = useState([]);
    const [formattedSeniorityLevels, setFormattedSeniorityLevels] = useState([]);
    const [formattedSpecialties, setFormattedSpecialties] = useState([]);
    const [endDate, setEndDate] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());

    const [availableEquipment, setAvailableEquipment] = useState([]);
    const [targetTechnicians, setTargetTechnicians] = useState([]);
    const [targetClients, setTargetClients] = useState([]);
    const [targetSites, setTargetSites] = useState([]);
    const [targetEquipment, setTargetEquipment] = useState([]);
    const [targetIssueTypes, setTargetIssueTypes] = useState([]);
    const [targetPriority, setTargetPriority] = useState([]);
    const [targetSkillLevel, setTargetSkillLevel] = useState([]);
    const [targetSkillType, setTargetSkillType] = useState([]);
    const [targetStatus, setTargetStatus] = useState([]);

    const [issueTypes, fetchIssueTypes] = useApi(() => ({
        url: IssueTypesUrl.expand()
    }), lambdaBaseApi);

    useEffect(() => {
        if (companyInfo.companyId) {
            fetchIssueTypes();
        }
    }, [companyInfo.companyId]);

    useEffect(() => {
        if (issueTypes.data) {
            const payload = issueTypes.data.map(issueType => {
                issueType.name = issueType.label;
                if (issueType.name === 'healthAndSafety') issueType.name = 'Health and Safety';

                return { id: issueType.id, name: issueType.name };
            });

            const formatted = payload;

            setFormattedIssueTypes(formatted);
        }
    }, [issueTypes]);

    const handleToggle = () => {
        setFilterOpen(!filterOpen);
    };

    const handleClickAway = () => {
        setFilterOpen(false);
    };

    const handleFilterApply = () => {
        setFilterOpen(false);
    };

    useEffect(() => {
        if (!isEmpty(seniorityLevels)) {
            const payload = seniorityLevels.map(seniorityLevel => {
                return { id: seniorityLevel.id, name: seniorityLevel.label };
            });

            const formatted = payload;

            setFormattedSeniorityLevels(formatted);
        }
    }, [seniorityLevels]);

    useEffect(() => {
        if (!isEmpty(specialties) && !isEmpty(specialties[0].items)) {
            const payload = specialties[0].items.map(specialtie => {
                return { id: specialtie.id, name: specialtie.label };
            });

            const formatted = payload;

            setFormattedSpecialties(formatted);
        }
    }, [specialties]);

    const handleChangeTechnician = event => {
        setTargetTechnicians(event.target.value);
    };

    const handleChangeClient = async event => {
        setTargetClients(event.target.value);
        await fetchClientSites(event.target.value[0].id);
    };

    const handleChangeSite = async event => {
        setTargetSites(event.target.value);

        const equipments = await fetchEquipmentsBySiteId(event.target.value[0].id);
        setAvailableEquipment(equipments);
    };

    const handleChangeEquipment = async event => {
        setTargetEquipment(event.target.value);
    };

    const handleChangeIssueType = event => {
        setTargetIssueTypes(event.target.value);
    };

    const handleChangePriority = event => {
        setTargetPriority(event.target.value);
    };

    const handleChangeSkillLevel = event => {
        setTargetSkillLevel(event.target.value);
    };

    const handleChangeSkillType = event => {
        setTargetSkillType(event.target.value);
    };

    const handleChangeStatus = event => {
        setTargetStatus(event.target.value);
    };

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 400
            },
        },
    };

    return (
        <ClickAwayListener
            mouseEvent={'onMouseUp'}
            onClickAway={handleClickAway}
        >
            <span>
                <Button
                    className={classes.FilterButton}
                    onClick={handleToggle}
                >
                    <i className="fas fa-filter" aria-hidden="true" />
                </Button>
                {
                    filterOpen ? 
                        <Paper className={classes.BobFilterComponentMenu} style={{ width: '500px' }}>
                            <div className={classes.ServiceManagementFilter} style={{ width: '100%' }}>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px'
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Technician
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetTechnicians}
                                        onChange={handleChangeTechnician}
                                        label="technician"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Technician Selected` : `${selected.length} Technicians Selected`}
                                        inputProps={{
                                            name: 'technician',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Technicians
                                        </MenuItem>
                                        {technicians.map((technician, index) => (
                                            <MenuItem key={index} value={technician}>
                                                <Checkbox style={{ color: 'black' }} checked={targetTechnicians.indexOf(technician) > -1} />
                                                <ListItemText primary={technician.fullName} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px'
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Issue Type
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetIssueTypes}
                                        onChange={handleChangeIssueType}
                                        label="issueTypes"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Issue Type Selected` : `${selected.length} Issue Types Selected`}
                                        inputProps={{
                                            name: 'issueTypes',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Issue Type
                                        </MenuItem>
                                        {formattedIssueTypes.map((type, index) => (
                                            <MenuItem key={index} value={type}>
                                                <Checkbox style={{ color: 'black' }} checked={targetIssueTypes.indexOf(type) > -1} />
                                                <ListItemText primary={type.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px'
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Client
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetClients}
                                        onChange={handleChangeClient}
                                        label="client"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Client Selected` : `${selected.length} Clients Selected`}
                                        inputProps={{
                                            name: 'client',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Client
                                        </MenuItem>
                                        {navClients.map((client, index) => (
                                            <MenuItem key={index} value={client}>
                                                <Checkbox style={{ color: 'black' }} checked={targetClients.indexOf(client) > -1} />
                                                <ListItemText primary={client.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px'
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Priority
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetPriority}
                                        onChange={handleChangePriority}
                                        label="priority"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Priority Selected` : `${selected.length} Priorities Selected`}
                                        inputProps={{
                                            name: 'priority',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Priority
                                        </MenuItem>
                                        {formattedPriorities.map((priority, index) => (
                                            <MenuItem key={index} value={priority}>
                                                <Checkbox style={{ color: 'black' }} checked={targetPriority.indexOf(priority) > -1} />
                                                <ListItemText primary={priority.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px'
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Site
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetSites}
                                        disabled={isEmpty(sites)}
                                        onChange={handleChangeSite}
                                        label="site"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Site Selected` : `${selected.length} Sites Selected`}
                                        inputProps={{
                                            name: 'site',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select site
                                        </MenuItem>
                                        {sites.map((site, index) => (
                                            <MenuItem key={index} value={site}>
                                                <Checkbox style={{ color: 'black' }} checked={targetSites.indexOf(site) > -1} />
                                                <ListItemText primary={site.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px'
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Skill Type
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetSkillType}
                                        onChange={handleChangeSkillType}
                                        label="skillType"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Type Selected` : `${selected.length} Types Selected`}
                                        inputProps={{
                                            name: 'skillType',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Skill Type
                                        </MenuItem>
                                        {formattedSpecialties.map((type, index) => (
                                            <MenuItem key={index} value={type}>
                                                <Checkbox style={{ color: 'black' }} checked={targetSkillType.indexOf(type) > -1} />
                                                <ListItemText primary={type.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px'
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Equipment
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetEquipment}
                                        disabled={isEmpty(availableEquipment)}
                                        onChange={handleChangeEquipment}
                                        label="equipment"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Equipnent Selected` : `${selected.length} Equipment Selected`}
                                        inputProps={{
                                            style: { fontSize: '1.2rem' },
                                            name:  'equipment',
                                            id:    'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Equipment
                                        </MenuItem>
                                        {availableEquipment.map((equipment, index) => (
                                            <MenuItem key={index} value={equipment}>
                                                <Checkbox style={{ color: 'black' }} checked={targetEquipment.indexOf(equipment) > -1} />
                                                <ListItemText primary={equipment.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px'
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Skill Level
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetSkillLevel}
                                        onChange={handleChangeSkillLevel}
                                        label="skillLevel"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Level Selected` : `${selected.length} Levels Selected`}
                                        inputProps={{
                                            name: 'skillLevel',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Skill Level
                                        </MenuItem>
                                        {formattedSeniorityLevels.map((level, index) => (
                                            <MenuItem key={index} value={level}>
                                                <Checkbox style={{ color: 'black' }} checked={targetSkillLevel.indexOf(level) > -1} />
                                                <ListItemText primary={level.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size="small" className={classes.TimeListData} >
                                    <InputLabel
                                        htmlFor="startDate"
                                        className={classes.TimeLabel}
                                    >
                                        Start Date
                                    </InputLabel>
                                    <DatePicker
                                        popperPlacement="top-start"
                                        className={classes.ScheduleFilterTime}
                                        selected={startDate}
                                        onChange={date => setStartDate(date)}
                                    />
                                </FormControl>
                                <FormControl size="small" className={classes.TimeListData}>
                                    <InputLabel
                                        className={classes.TimeLabel}
                                        htmlFor="endDate"
                                    >
                                        End Date
                                    </InputLabel>
                                    <DatePicker
                                        popperPlacement="top-start"
                                        className={classes.ScheduleFilterTime}
                                        selected={endDate}
                                        onChange={date => setEndDate(date)}
                                    />
                                </FormControl>
                                <FormControl variant="outlined" size="small" className={classes.FilterListData}>
                                    <InputLabel
                                        style={{
                                            backgroundColor: 'white',
                                            paddingRight:    '5px',
                                            zIndex:          5
                                        }}
                                        htmlFor="outlined-contact-native-simple"
                                    >
                                        Status
                                    </InputLabel>
                                    <Select
                                        className={classes.Font}
                                        MenuProps={MenuProps}
                                        multiple
                                        value={targetStatus}
                                        onChange={handleChangeStatus}
                                        label="status"
                                        renderValue={(selected) => selected.length === 1 ? `${selected.length} Status Selected` : `${selected.length} Statuses Selected`}
                                        inputProps={{
                                            name: 'status',
                                            id:   'outlined-contact-native-simple',
                                        }}
                                    >
                                        <MenuItem value="none" disabled>
                                            Select Status
                                        </MenuItem>
                                        {statusList.map((status, index) => (
                                            <MenuItem key={index} value={status}>
                                                <Checkbox style={{ color: 'black' }} checked={targetStatus.indexOf(status) > -1} />
                                                <ListItemText primary={status.status} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div>
                                <BobCancelButton
                                    className={classes.Buttons}
                                    label={'Cancel'}
                                    cancel={handleToggle}
                                />
                                <BobConfirmButton
                                    className={classes.Buttons}
                                    label={'Ok'}
                                    onClick={handleFilterApply}
                                />
                            </div>
                        </Paper>
                        :
                        null
                }
            </span>
        </ClickAwayListener>
    );
};

BobServiceManagementFilter.defaultProps = {
    label: '',
    data:  []
};

BobServiceManagementFilter.propTypes = {
    label: string,
    data:  array
};

const mapStateToProps = state => {
    return {
        companyInfo:     state.companyInfo,
        navClients:      state.bob.navClients,
        sites:           state.site.sites,
        targetNavClient: state.bob.targetNavClient,
        targetNavSite:   state.bob.targetNavSite,
        technicians:     state.scheduler.technicians
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...BobActions,
    ...SiteActions,
    ...UiActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BobServiceManagementFilter));
